import { QueryClient } from '@tanstack/react-query'

/**
 * Creates a new QueryClient instance with default configuration
 *
 * This factory function creates a fresh QueryClient per request to avoid
 * sharing state between users in server components.
 *
 * Default options:
 * - staleTime: 60 seconds - data is considered fresh for 1 minute
 * - refetchOnWindowFocus: false - don't refetch when user returns to tab
 * - retry: 1 - retry failed requests once before giving up
 */
export function getQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 60 seconds
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  })
}
